import {BudgetFieldsNames} from "../../real_estate/types/BudgetFieldsNames";

export enum ForYouBudgetFieldsNames {
    RADIO = `forYou_${BudgetFieldsNames.RADIO}`,
    CREDIT = `forYou_${BudgetFieldsNames.CREDIT}`,
    TOTAL = `forYou_${BudgetFieldsNames.TOTAL}`
}
import {BudgetFieldsNames} from "../../real_estate/types/BudgetFieldsNames";

export enum ForYouBudgetFieldsNames {
    RADIO = `forYou_${BudgetFieldsNames.RADIO}`,
    CREDIT = `forYou_${BudgetFieldsNames.CREDIT}`,
    TOTAL = `forYou_${BudgetFieldsNames.TOTAL}`
}
